import { Component, OnInit } from '@angular/core';
import {CardTextsmaster} from "../models/card_textsmaster";
import {CardTextsService} from "../services/card_texts.service";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
declare var $ :any;
declare var bootbox: any;
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-card_textslist',
  templateUrl: './card_textslist.component.html'
})
export class CardTextslistComponent implements OnInit {

    p: number[] = [];
    searchText: string = ''; 
    card_id: number = 0;
    card_textslist:CardTextsmaster[];

    constructor(
        private cardTextsService:CardTextsService,
        private router:Router,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        console.log(this.activatedRoute)
        this.activatedRoute.params.subscribe(params => {
            if(params['id']) {
                this.card_id = params['id'];
                console.log("CardId======>",this.card_id); // Print the parameter to the console.
            }
        });

        this.getCardTexts(0,{sortColumn: 'card_texts_id', sortDirection:'desc'});
        // $(document).ready(function() {
        //     $("#datatable").DataTable();
        // });
    }

    onSorted($event){
        this.getCardTexts(0,$event);
    }

    getCardTexts=function(pageId,criteria: CardTextsListSearchCriteria){
        this.cardTextsService.getCardTextsList(pageId,this.searchText,this.card_id).then(data => {
            console.log("CardTextsList =======>",data);
            this.card_textslist = data['data']['data'];
            this.totaloffset = data['data'].Totaloffset;
            this.itemsperpage = data['data'].ItemsPerPage;
            this.SortCardTexts(criteria);     
        });
    }

    SortCardTexts(criteria: CardTextsListSearchCriteria): CardTextsmaster[] {
        return this.card_textslist.sort((a,b) => {
          if(criteria.sortDirection === 'desc'){
            if (a[criteria.sortColumn] < b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
          else {
            if (a[criteria.sortColumn] > b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
        });
    }

    viewCardTexts(card_texts_id){
        this.router.navigate(['/card_texts/',card_texts_id]);
    }

    deleteCardTextCall(card_texts_id,i){
        this.cardTextsService.deleteCardTextCall(card_texts_id).then(data => {
            console.log(data['code'])
            if(data['code'] === 200){
                $.toast({heading: 'Success', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.getCardTexts(0,{sortColumn: 'card_name', sortDirection:'desc'});
                // this.router.navigate(['/card_texts']);
            }else{
                $.toast({heading: 'Warning', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
            }
        }).catch(err => {
            if(err['code'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
        });
    }

    deleteCardConfirm(card_texts_id,i){
        var _this = this;
        bootbox.confirm({
            message: "Are you sure you want to delete this record?",
            buttons: {
                confirm: {label: 'Yes',className: 'btn-success btn-flat'},
                cancel: {label: 'No',className: 'btn-default btn-flat'}
            },
            callback: function (result) {
                if(result) {
                    _this.deleteCardTextCall(card_texts_id,i);
                }
            }
        });
    }

}

export class CardTextsListSearchCriteria {
    sortColumn: string;
    sortDirection: string;
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/card_textsmaster/card_textslist/card_textslist.component.ts